import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';

import { CHARACTER_IMGS } from '@_shared/imgs';
import { eventPush } from '@_shared/libs';
import { Typography } from '@_shared/ui/Typography';

import * as S from './Banner.style';

export function Banner() {
	const navigate = useNavigate();

	const [counter, setCounter] = useState<number>(1);

	// Signup Slide Settings
	const settings = {
		dots: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,

		centerMode: true,
		centerPadding: '20px',

		infinite: true,
		autoplay: true,
		autoplaySpeed: 7000,

		draggable: false,
		swipe: true,
		arrows: false,
		afterChange: (current: number) => {
			setCounter(current + 1);
		},

		style: {
			width: '100%',
			position: 'relative',
		},
	};
	return (
		<S.Banner>
			<Slider {...settings}>
				<S.BannerItem
					bgColor="red-quaternary"
					onClick={() => {
						window.location.href =
							'https://www.instagram.com/talkak.official?igsh=aTN5MzBwMXNudjR6';
					}}
				>
					<S.BannerTitle>
						딸깍의 New 소식이
						<br />
						궁금하다면?
					</S.BannerTitle>
					<Typography type="body-medium" color="orange-primary">
						다음 업데이트 미리보기
					</Typography>
					<S.CharacterIMG1 src={CHARACTER_IMGS.CAMERA_CHARACTER_IMG} alt="BannerIMG1" />
				</S.BannerItem>

				<S.BannerItem
					bgColor="warmgray-100"
					onClick={() => {
						window.location.href = 'https://clickclick.kr/settings/announcement/6';
					}}
				>
					<S.BannerTitle>
						서비스에 관한 여러분의
						<br />
						의견을 들려주세요!
					</S.BannerTitle>
					<Typography type="body-medium" color="orange-primary">
						더 알아보기
					</Typography>
					<S.CharacterIMG2 src={CHARACTER_IMGS.READING_CHARACTER_IMG} alt="BannerGIF" />
				</S.BannerItem>

				<S.BannerItem
					bgColor="orange-tertiary"
					onClick={() => {
						eventPush('사용설명서.배너.click');
						navigate('/onboarding');
					}}
				>
					<S.BannerTitle>
						나중에 다시 볼 콘텐츠
						<br />
						클릭 한번으로 담아보세요!
					</S.BannerTitle>
					<Typography type="body-medium" color="orange-primary">
						딸깍 사용설명서
					</Typography>
					<S.CharacterIMG3
						src={CHARACTER_IMGS.MAGNIFYING_GLASS_CHARACTER_IMG}
						alt="BannerGIF"
					/>
				</S.BannerItem>
			</Slider>

			<S.CounterContainer>
				<Typography type="body-medium" color="white-primary">
					{counter} / 3
				</Typography>
			</S.CounterContainer>
		</S.Banner>
	);
}

export default Banner;
